const apiConfig = {
    APP_ID: 'tra',

    memberDomain: process.env.VUE_APP_MEMBER,
    otpRegister: '/member/v4/otpRegister',
    checkOtpRegister: '/member/v4/checkOtpRegister',
    otpLogin: '/member/v4/otpLogin',
    checkOtpLogin: '/member/v4/checkOtpLogin',
    refreshToken: '/member/v4/refreshToken',
    logout: '/member/v4/logout',
    esunWalletSearch: '/walletApi/search',
    isOverflow: '/member/v4/isOverflow',
    userApiGet: '/userapi/v1/get',

    activityDomain: process.env.VUE_APP_ACTIVITY,
    insertProfile: '/coins/v2/insertProfile',
    checkAnswer:'/coins/v2/checkAnswer',
    searchReply: '/coins/v2/searchReply',
    recordAction: '/coins/v2/recordAction',
    showLotteryRecord:'/coins/v2/showLotteryRecord',
    lottery:'/coins/v2/lottery',
    memberCheck: '/coins/v2/memberCheck',

    clarityDomain: process.env.VUE_APP_CLARITY,
    event:'/v1/event',

    lotteryList: process.env.VUE_APP_LOTTERY_LIST,

}

export default apiConfig;